"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItem = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var responsiveProp_1 = __importDefault(require("../responsiveProp"));
var DEFAULT_ELEMENT = 'div';
var spanToClassName = function (cols) {
    switch (cols) {
        case 'auto':
            return 'flex-grow';
        case 'inline':
            return 'w-auto';
        case 12:
            return 'w-full';
        default:
            return "w-" + cols + "/12";
    }
};
exports.GridItem = react_1.default.forwardRef(function AOGridItem(_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.as, ElementType = _b === void 0 ? DEFAULT_ELEMENT : _b, span = _a.span, props = __rest(_a, ["children", "className", "as", "span"]);
    return (react_1.default.createElement(ElementType, __assign({ className: classnames_1.default(span ? responsiveProp_1.default(span, spanToClassName) : 'flex-grow', className) }, props, { "data-aods": "grid-item", ref: ref }), children));
});
exports.default = exports.GridItem;
//# sourceMappingURL=GridItem.js.map